import React, { useState, useEffect } from 'react';
import ApproveSkillCardComponent from './ApproveSkillCardComponent';
import PaginationComponent from '../../components/Pagination/Pagination';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION, WFHAttribute } from '../../constants';
import { getAllSkillsMapping } from '../Services/SkillsService';
import GenericLoader from '../../components/Loader/GenericLoader';
import {
  Switch,
  Tooltip,
  Grid,
  Typography,
  Autocomplete,
  TextField,
} from '@mui/material';
import { getUsers } from '../../services/UserService';

const ApproveSkill = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalPage, setTotalPage] = useState();
  const [pageNo, setPageNo] = useState(0);
  const [refreshPage, setRefreshPage] = useState(false);
  const [skills, setSkills] = useState([]);
  const [showError, setShowError] = useState(false);
  const [loader, setLoader] = React.useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [toggle, setToggle] = React.useState(false);
  const [selected, setSelected] = useState('');
  const [search, setSearch] = useState(false);
  const [users, setUsers] = useState([]);
  const [isLastActionFocus, setIsLastActionFocus] = useState(false);
  const [filterData, setFilterData] = React.useState({
    employeeId: '',
    employeeName: '',
    status: '',
    skillId: '',
    skillName: '',
  });
  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const loadData = async () => {
    const response = await getAllSkillsMapping(pageSize, pageNo, filterData);
    if (response.status !== 200) {
      dipatchNotification(response.type, response.message);
    }
    if (response.isError === false) {
      setTotalPage(response.data.data.totalPages);
      setSkills(response.data.data.content);
      setLoader(false);
    }
  };

  const getNames = async (name) => {
    setIsLoading(true);
    const userList = await getUsers(name);
    setUsers((prev) => []);
    if (userList.data.content) {
      userList.data.content.forEach((user) => {
        const newObj = {
          value: user.id,
          label: user.firstName + ' ' + (user?.lastName || '') + ' (' + user.employeeCode + ')',
        };
        setUsers((prev) => [...prev, newObj]);
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getNames();
  }, []);

  useEffect(() => {
    loadData();
    getNames();
  }, [refreshPage, filterData]);

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
    setRefreshPage(!refreshPage);
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefreshPage(!refreshPage);
  };

  const handleToggleChange = () => {
    if (toggle === false) {
      setFilterData((prevState) => ({
        ...prevState,
        status: 'APPROVED',
      }));
    } else {
      setFilterData((prevState) => ({
        ...prevState,
        status: '',
      }));
    }
    setToggle(!toggle);
    setPageNo(0);
    setPage(1);
    setRefreshPage(!refreshPage);
  };

  const checkOptions = (str) => {
    if (str.length > 1) {
      setIsLastActionFocus(false);
      getNames(str);
      setSelected(str);
      setSearch(true);
    } else if (str === '') {
      setFilterData({ ...filterData, employeeId: null });
      setUsers(() => []);
      setSearch(false);
    } else setSearch(false);
  };

  const handleCloseDropdown = (event) => {
    setSearch(false);
  };
  return (
    <>
      <Grid
        container
        className="space-between-container"
        alignItems="center"
        sx={{ mb: 1, mt: 1 }}
      >
        <Autocomplete
          freeSolo
          id="jhghj"
          open={search}
          options={users}
          getOptionLabel={(option) => option.label}
          onInputChange={(e, val) => checkOptions(val)}
          onChange={(e, val) => {
            setSelected(val);
            setFilterData({ ...filterData, employeeId: val?.value });
            setSearch(false);
          }}
          onBlur={handleCloseDropdown}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField {...params} variant="standard" label="Search Employee" />
          )}
          sx={{ width: '280px' }}
        />
        <Tooltip
          placement="top"
          title={toggle ? 'Show all requests' : 'Show approved requests'}
        >
          <Switch
            checked={toggle && filterData.status === 'APPROVED'}
            onChange={handleToggleChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </Tooltip>
      </Grid>
      <>
        {loader ? (
          <div>
            <GenericLoader
              rectAttributes={WFHAttribute}
              showError={showError}
              setShowError={setShowError}
            />
          </div>
        ) : (
          <>
            {/* filter will be here */}
            <Box
              sx={{
                overflow: 'hidden',
              }}
            >
              {skills.length != 0 ? (
                skills?.map((skill, index) => {
                  return (
                    <ApproveSkillCardComponent key={index} skill={skill} />
                  );
                })
              ) : (
                <Grid
                  container
                  item
                  md={3}
                  xs={3}
                  sx={{ height: '350px', m: 'auto' }}
                >
                  <Typography sx={{ mt: 'auto', mb: 'auto' }}>
                    No skill mapping
                  </Typography>
                </Grid>
              )}
            </Box>
            {skills?.length ? (
              <Box className="page-holder mb-2">
                <PaginationComponent
                  count={totalPage}
                  page={page}
                  pageChange={pageChange}
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                />
              </Box>
            ) : (
              <></>
            )}
          </>
        )}
      </>
    </>
  );
};

export default ApproveSkill;
